import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import Dealership from "../pages/dealership/page";
import Auth from "../pages/auth/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/bayilik",
    element: <Dealership />,
  },
  {
    path: "/giris",
    element: <Auth />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;